import { apiClient } from './apiClient';

export interface FeedbackDto {
  id: string;
  rating: number;
  message: string;
  userId: string | null;
  userEmail: string | null;
  created: string;
  updated: string | null;
}

export interface CreateFeedbackRequest {
  rating: number;
  message: string;
  email?: string;
}

/**
 * Submit feedback (available to everyone)
 */
export async function submitFeedback(request: CreateFeedbackRequest): Promise<FeedbackDto> {
  return apiClient.post<CreateFeedbackRequest, FeedbackDto>('/api/Feedback', request, true);
}

/**
 * Get all feedback (Admin only)
 */
export async function getAllFeedback(): Promise<FeedbackDto[]> {
  return apiClient.get<FeedbackDto[]>('/api/Feedback', true);
}

/**
 * Get feedback by ID (Admin only)
 */
export async function getFeedbackById(id: string): Promise<FeedbackDto> {
  return apiClient.get<FeedbackDto>(`/api/Feedback/${id}`, true);
}

/**
 * Delete feedback (Admin only)
 */
export async function deleteFeedback(id: string): Promise<void> {
  return apiClient.delete<void>(`/api/Feedback/${id}`, true);
}
